import { Menu, Transition } from '@headlessui/react'
import {
  LogoutIcon,
  QuestionMarkCircleIcon,
  RefreshIcon,
  UserCircleIcon,
} from '@heroicons/react/solid'
import { savedTokens, useAuth } from 'src/auth'
import {
  useReloadOrganization,
  useReloadOrganizations,
} from 'src/routes/Organization/Client/queries'
import { checkAdmin } from 'src/utils/validation'
import LoginButtonMenuItem from './LoginButtonMenuItem'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { getEnvString } from 'src/utils'

type Props = {
  disableLogin?: boolean
  displayHelp?: boolean
}

export default function LoginButton(props: Props) {
  const { login, logout, isLoading } = useAuth()
  const [tokens] = savedTokens.useState(null)
  const reloadOrganization = useReloadOrganization()
  const reloadOrganizations = useReloadOrganizations()

  if (!tokens) {
    return (
      <CustomButton
        onClick={login}
        label="Login"
        loadingLabel="Logging in"
        isLoading={isLoading}
        className="!border-slate-200 hover:!border-slate-300 active:!bg-slate-200 active:!border-slate-200 focus-visible:!border-theme-500 disabled:!border-slate-200"
        icon={<UserCircleIcon />}
        iconPosition="left"
        disabled={props.disableLogin}
      />
    )
  }

  return (
    <Menu as="div" className="flex">
      <Menu.Button className="flex flex-row items-center">
        <div className="flex flex-col flex-1 mr-3 text-sm leading-4 text-right">
          <div className="font-semibold text-slate-700">{tokens.username}</div>
          <div className="font-medium text-slate-500">{tokens.region}</div>
        </div>

        <div className="flex items-center justify-center w-8 h-8 font-semibold text-white rounded-full bg-theme-500">
          {tokens.username.slice(0, 1).toUpperCase()}
        </div>
      </Menu.Button>
      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 w-56 mt-10 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-1 py-1 ">
            {checkAdmin(tokens.organization) ? (
              <LoginButtonMenuItem
                label="Reload Organizations"
                icon={RefreshIcon}
                onClick={() => reloadOrganizations.mutate()}
              />
            ) : (
              <LoginButtonMenuItem
                label="Reload Organization"
                icon={RefreshIcon}
                onClick={() =>
                  reloadOrganization.mutate({
                    organization: tokens.organization,
                  })
                }
              />
            )}
            {props.displayHelp && (
              <LoginButtonMenuItem
                label="Help"
                icon={QuestionMarkCircleIcon}
                onClick={() =>
                  window.open(getEnvString('REACT_APP_HELP_URL'), '_blank')
                }
              />
            )}

            <LoginButtonMenuItem
              label="Logout"
              icon={LogoutIcon}
              onClick={logout}
            />
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
